import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context.js";
import { LoadingSpinner } from "./LoadingSpinner.js";

/**
 * Gates the creator, host and report routes on being signed in.
 *
 * Signed in, not admin: the server authorizes each of those routes against the
 * owning user (quizzes by `ownerId`, sessions and reports by `hostId`), so a
 * signed-in user only ever sees their own. `User.isAdmin` exists but nothing
 * reads it — adding a role gate here would lock out anyone who registers while
 * registration is open, since there is no way to grant the flag.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  return <>{children}</>;
}
